import React from 'react'
import { FormattedMessage } from 'react-intl'

import IconCanceled from '@/checkout-instore-legacy/components/Commons/Icons/Canceled'
import getClassStyle from '@/checkout-instore-legacy/utils/getClassStyle'
import { useMediaQuery } from '@/checkout-instore-legacy/hooks/mediaQuery'

export function NoResults({
  term,
  hasFilters,
}: {
  term: string
  hasFilters: boolean
}) {
  const { value: isNotSmall } = useMediaQuery({
    s: false,
    ns: true,
    m: true,
    l: true,
    xl: true,
  })

  return (
    <div
      id="search-noresults"
      className="flex flex-column h-100-ns w-100 vh-50 justify-center tc"
    >
      {term && (
        <>
          <div className="center mb5 mb7-ns">
            <IconCanceled
              width={isNotSmall ? 60 : 30}
              height={isNotSmall ? 60 : 30}
              color={getClassStyle('c-muted-2', 'color')}
              // @ts-expect-error ts-migrate(2322) FIXME: Type '{ width: number; height: number; color: stri... Remove this comment to see the full error message
              animate={false}
            />
          </div>
          <div className="lh-copy f3-ns ph5 ph7-ns">
            <span className="c-muted-2">
              <FormattedMessage id="searchNotFound" /> <strong>{term}</strong>
              {hasFilters ? (
                <FormattedMessage id="searchNotFoundWithFilters" />
              ) : null}
              .
            </span>
          </div>
        </>
      )}
    </div>
  )
}
